import { observer } from 'mobx-react-lite';
import React from 'react';

import { Group } from 'STORE/Groups/Group';

import { GroupChatInfo } from '../GroupChatInfo/GroupChatInfo';

interface IGroupChatInfoProps {
  group: Group;
}

export const ServiceMessagesChatInfo: React.FC<IGroupChatInfoProps> = observer(({ group }) => {
  return (
    <GroupChatInfo
      group={group}
      hideMembersCount
    />
  );
});
